import { Link, useLocation } from 'react-router-dom'
import { useReceiptMeta } from '../api/queries'
import { useAuth } from '../auth/AuthProvider'
import { useModuleEnabled } from '../navigation'

/**
 * Antal kvitteringer, der venter på godkendelse - 0 for alle andre end kontoret (Kontor og administratorer),
 * og når modulet er slået fra. Der spørges slet ikke, hvis man ikke er på kontoret.
 */
export function usePendingReceiptCount(): number {
  const { isIntranetAdmin } = useAuth()
  const moduleEnabled = useModuleEnabled()
  const enabled = isIntranetAdmin && moduleEnabled('receipts')
  const { data } = useReceiptMeta(enabled)
  return enabled && data?.canDecide ? data.pendingCount : 0
}

/**
 * Stribe øverst på alle sider, når der er kvitteringer til godkendelse (Simon 2026-10-01: "Det skal være rigtig
 * tydeligt"). Kun for kontoret. Den kan ikke lukkes væk - den forsvinder, når kvitteringerne er godkendt eller
 * afvist. Ikke på selve kvitteringssiden, hvor listen står lige under.
 */
export function PendingReceiptsBanner() {
  const count = usePendingReceiptCount()
  const location = useLocation()

  if (count === 0 || location.pathname === '/receipts') return null

  return (
    <div className="banner banner--receipts">
      <span aria-hidden style={{ fontSize: 22 }}>🧾</span>
      <span style={{ flex: 1 }}>
        <b>
          {count === 1 ? '1 kvittering venter' : `${count} kvitteringer venter`} på godkendelse
        </b>
      </span>
      <Link className="btn btn--primary btn--sm" to="/receipts?vis=godkendelse">
        Godkend nu
      </Link>
    </div>
  )
}
